import { PostDetail } from 'types/PostDetail';
import { getCardMedia } from 'app/modules/posts/utils/cardMedia';

export const getPostAttachmentCount = (
  cards: PostDetail['attachments']['cards'],
) => {
  const counts = { videos: 0, images: 0, documents: 0 };
  for (const card of cards) {
    const media = getCardMedia(card);
    if (!media) continue;
    if (media.kind === 'document') counts.documents += 1;
    else if (media.kind === 'video') counts.videos += 1;
    else counts.images += 1;
  }
  return counts;
};
